export default "__VITE_ASSET__fa9f5f17__"